import { template as template_b30e295b05a2433080acca5450296a75 } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import RequestValidatedInput from 'client-portal/components/request/validated-input';
import SharedMaskedInput from 'ember-simplepractice/components/shared/masked-input';
import t from 'ember-intl/helpers/t';
export default template_b30e295b05a2433080acca5450296a75(`
  <div class="row">
    <div class="col-12" data-test-date-of-birth>
      <label class="required" for="waitlist-date-of-birth">
        {{t "site.waitlistIntake.fields.dateOfBirth"}}
      </label>
      <RequestValidatedInput @model={{@form}} @path="dateOfBirth" @isDirty={{@form.isDirty}}>
        <SharedMaskedInput
          @type="date"
          @value={{@form.dateOfBirth}}
          @onChange={{fn @onUpdate "dateOfBirth"}}
          @inactivePlaceholder={{t "site.waitlistIntake.placeholders.dateOfBirth"}}
          id="waitlist-date-of-birth"
          data-test-date-input
        />
      </RequestValidatedInput>
    </div>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
